import { useDispatch } from 'react-redux';

import './oppaTutorial.scss';

import { ArrowButton } from '../../../../components/common/ArrowButton/ArrowButton';
import { STEP_LIST_IDS } from '../../../../components/containers/StepList/stepListConstants';
import { stepListActions } from '../../../../components/containers/StepList/stepListSlice';
import { useInternationalization } from '../../../../hooks/useTranslationHook';
import { ArrowBig } from '../../../../icons/arrow-icon-big';
import { SkipIcon } from '../../../../icons/skip-icon';
import { modalActions } from '../../../../components/containers/Modal/modalSlice';
import { oppaTutorialSteps } from './oppaTutorial';

export const OppaTutorialStep2 = () => {
  const { formatMessage } = useInternationalization();
  const dispatch = useDispatch();

  const handleNextStep = () => {
    dispatch(stepListActions.nextStep({ stepListId: STEP_LIST_IDS.oppaTutorialStepList }));
  };

  const handleSkip = () => {
    dispatch(
      modalActions.openPromptModal({
        title: 'Are you sure you want to finish?',
        btnText: 'Yes, exit',
        onButtonClick: () => {
          localStorage.setItem('oppaCompletedTutorial', true);
          dispatch(
            stepListActions.setStep({
              stepListId: STEP_LIST_IDS.oppaTutorialStepList,
              stepId: oppaTutorialSteps.stepNull,
            }),
          );
          dispatch(modalActions.closeModal());
        },
      }),
    );
  };

  return (
    <div className="oppa-tutorial__blackout-step2">
      <div className="oppa-tutorial__skip" onClick={() => handleSkip()}>
        {formatMessage('Skip')}
        <SkipIcon className="oppa-tutorial__skip-icon" />
      </div>
      <ArrowBig className="oppa-tutorial__arrow" />
      <div className="oppa-tutorial__descriptionBox-bottom">
        <div className="achievements-tutorial__descriptionBox-step">1/5</div>
        <div className="oppa-tutorial__descriptionBox-header">{formatMessage('OPPA account number')}</div>
        <div className="oppa-tutorial__descriptionBox-description">
          {formatMessage(
            'Here is the account number you have used for registration. It automatically attaches to your profile and will be used for coins redemption',
          )}
        </div>
      </div>
      <ArrowButton customClass={'oppa-tutorial__button-next'} onClick={handleNextStep} />
    </div>
  );
};
